import { useMutation } from "@tanstack/react-query";

import { changePassword, updateAvatar, updateProfile } from "@/data/account";

export function useChangePassword() {
  return useMutation({ mutationFn: changePassword });
}

export function useUpdateAvatar() {
  return useMutation({
    mutationFn: (avatar: string | null) => updateAvatar(avatar),
  });
}

export function useUpdateProfile() {
  return useMutation({ mutationFn: updateProfile });
}
